import { render } from "./ProductsList.vue?vue&type=template&id=494704f2"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ZyMall/components/products/ProductsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "494704f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('494704f2', __exports__)) {
    api.reload('494704f2', __exports__)
  }
  
  module.hot.accept("./ProductsList.vue?vue&type=template&id=494704f2", () => {
    api.rerender('494704f2', render)
  })

}


export default __exports__